import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af584cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-3" }

import section1 from './section-1.vue';
  import section2 from './section-2.vue';
  import section3 from './section-3.vue';
  import { IEmartProgram } from '../../type';

  export interface IProps {
    program: IEmartProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

  ;

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(section1, { program: __props.program }, null, 8, ["program"]),
    _createVNode(section2, { program: __props.program }, null, 8, ["program"]),
    _createVNode(section3)
  ]))
}
}

})